/* eslint-disable */
import React from "react";
import back_asset from "../../assets/01_Home/Icon_Left.svg";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";

interface HeaderComponentProps {
  news: any;
}

const FormatearFecha = ({ fechaISO }: any) => {
  const fecha = new Date(fechaISO);

  const opciones: any = {
    day: "2-digit",
    month: "long",
    year: "numeric",
  };

  const fechaFormateada = fecha.toLocaleDateString("es-ES", opciones);

  return <span>{fechaFormateada}</span>;
};

const ContenidoComponent: React.FC<HeaderComponentProps> = ({ news }) => {
  return (
    <div className="contenido-normal-news">
      <div className="title">{news?.title}</div>
      <div className="date">
        Publicado el <FormatearFecha fechaISO={news?.creation_datetime} />
      </div>
      {/* <div className="autor">Autor: Hyundai Colombia</div> */}
      <img className="portada" src={`https://manager.hyundaicolombia.co/${news?.media?.url}`} />
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: news?.content?.content }}
      ></div>
      <div className="tags">
        {news?.content?.tags?.map((item: any) => (
          <div className="tag">{item?.tag}</div>
        ))}
      </div>
    </div>
  );
};

export default ContenidoComponent;
